import $ from 'jquery';
import 'jquery.mmenu';
$(document).ready(function( $ ){
  const $navbarHtml = [$('#wow-menu__mmmenu-adress').html()];
  $('#wow-menu__navmobile').mmenu({
    scrollBugFix: {
      fix: false
    }
  });
});